import React, { Component } from 'react';
import { 
  Tab, Tabs, Spinner, Button, Dialog, Classes
} from "@blueprintjs/core";
import { observable } from 'mobx';
import { observer, inject } from 'mobx-react';
import styled from '@emotion/styled';

const SecondSidebar = styled('div')`     
    width: 100%;
    height: calc(100vh - 75px);
    border-right: 1px solid #E6E8F1;
    padding: 0px 0px 15px;        
    background-color: #ffffff;
    position: sticky;
    top: 45px;
`

@inject('store', 'viewStore', 'userStore') @observer
class UserSidebar extends Component {

  @observable isOpenUserSidebar = false;

  // The route handler loads the list (Router.js, /dashboard/users/:section).
  openSection(section) {
    const { viewStore } = this.props;
    viewStore.userSearch = { ...viewStore.userSearch, section, term: '' };
    viewStore.users();
  }

  render(){
    let {
      viewStore
    } = this.props;
    const invitations = viewStore.userSearch.section === 'invitations';
    return(
      <SecondSidebar className="sidebar-mobile">
        <div className="mobile-dropdown">
          <div className="setting-icon"><img src="/settings.svg" onClick={() => this.isOpenUserSidebar = !this.isOpenUserSidebar}/></div>  
          <div className={this.isOpenUserSidebar ? "ssidebar-wrap " : "ssidebar-wrap ssidebar-wrap-hide" }>
            {/* <p className="mb-2"><strong>User</strong></p> */}
            <ul className="list-unstyled setting-list">              
              <li className={(viewStore.currentView === "Pages.Users.Index" && !invitations) || viewStore.currentView === "Pages.Users.Show" ? 'active' : ''}><a onClick={() => this.openSection('all')}>Users</a></li>
              <li className={viewStore.currentView === "Pages.Users.Index" && invitations ? 'active' : ''}><a onClick={() => this.openSection('invitations')}>Invitations</a></li>
              <li className={viewStore.currentView === "Pages.Users.Vacations" ? 'active' : ''}><a onClick={() => { viewStore.usersVacations() }}>Vacations</a></li>              
            </ul>            
            </div>
        </div>
      </SecondSidebar>
    )
  }
}
  
export default UserSidebar;